import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e751f60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attendance-table" }
const _hoisted_2 = {
  class: "full-width",
  style: {"z-index":"3"}
}
const _hoisted_3 = { class: "p-px-3 p2 medium text-light-gray p-d-flex p-ai-center p-jc-start middle-height" }
const _hoisted_4 = {
  class: "p-px-3 p3 medium bg-gray-2 p-d-flex p-ai-center p-jc-start text-light-gray full-width middle-height",
  style: {"border-radius":"var(--border-radius) 0 0 0"}
}
const _hoisted_5 = {
  class: "p-px-3 p-d-flex",
  style: {"z-index":"2"}
}
const _hoisted_6 = { class: "full-width p-d-flex p-ai-center p-jc-center bg-gray-2" }
const _hoisted_7 = { class: "p-d-flex p-jc-center full-width" }
const _hoisted_8 = {
  key: 0,
  class: "p-d-flex p-ai-center p-jc-center cell--today check",
  style: {"height":"72px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-d-flex p-flex-column bg-black",
  style: {"width":"72px","height":"112px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "middle-height" }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "middle-height bg-gray-2",
    style: {"border-radius":"0 var(--border-radius) 0 0"}
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_card = _resolveComponent("profile-card")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_icon_circle = _resolveComponent("icon-circle")!
  const _component_icon = _resolveComponent("icon")!
  const _component_check = _resolveComponent("check")!
  const _component_close_circle = _resolveComponent("close-circle")!
  const _component_overlay_menu = _resolveComponent("overlay-menu")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.tutor && Object.keys(_ctx.tutor).length > 0)
      ? (_openBlock(), _createBlock(_component_profile_card, {
          key: 0,
          name: _ctx.tutor.fullName,
          category: _ctx.tutor.category,
          imageLink: _ctx.tutor.avatar,
          class: "p-mt-6 p-mb-4"
        }, null, 8, ["name", "category", "imageLink"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DataTable, {
        value: _ctx.data,
        scrollable: true,
        scrollHeight: "calc(100vh - 150px)",
        scrollDirection: "both",
        stripedRows: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "name",
            style: {"width":"300px"},
            frozen: ""
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.data.length && `${_ctx.data.length} ${_ctx.filterTitle}`), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.copies.attendance), 1)
              ])
            ]),
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_profile_card, {
                  name: slotProps.data.name,
                  category: slotProps.data.inactive ? 'Inactivo' : slotProps.data.beca ? 'Beca' : '',
                  size: 'medium',
                  imageLink: slotProps.data.avatar,
                  link: `/profile/${slotProps.data.id}`,
                  blocked: slotProps.data.blocked
                }, null, 8, ["name", "category", "imageLink", "link", "blocked"])
              ])
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
            return (_openBlock(), _createBlock(_component_Column, {
              field: col.field,
              key: col.field,
              style: {"width":"100px"}
            }, {
              header: _withCtx(() => [
                _createElementVNode("p", {
                  class: _normalizeClass(["p3 medium text-light-gray p-d-flex p-ai-center p-jc-center middle-height", _ctx.todayScheduleId === col.field ? 'cell--today border-top' : 'full-width'])
                }, _toDisplayString(_ctx.todayScheduleId === col.field ? 'Hoy' : col.header), 3),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["p3 regular text-white p-d-flex p-ai-center p-jc-center middle-height", _ctx.todayScheduleId === col.field ? 'cell--today' : ''])
                  }, _toDisplayString(_ctx.attendances[index]), 3)
                ])
              ]),
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.todayScheduleId === col.field)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_Checkbox, {
                          modelValue: _ctx.checked[slotProps.data.id],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.checked[slotProps.data.id]) = $event),
                          binary: true,
                          onChange: () => _ctx.handleChange(slotProps.data.id),
                          class: "bigCheckbox",
                          style: {"font-size":"6px"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(`icon ${
                !!slotProps.data.attendance[col.field] && !slotProps.data.flagDate[col.field] ? 'icon-true' : 'icon-false'
              }`)
                      }, [
                        (slotProps.data.flagDate[col.field])
                          ? (_openBlock(), _createBlock(_component_icon, {
                              key: 0,
                              strokeColor: 'var(--gray-0)',
                              size: 22
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_icon_circle)
                              ]),
                              _: 1
                            }, 8, ["strokeColor"]))
                          : (_openBlock(), _createBlock(_component_icon, {
                              key: 1,
                              strokeColor: !!slotProps.data.attendance[col.field] ? 'var(--dark-gray)' : 'var(--light-gray)',
                              size: !!slotProps.data.attendance[col.field] ? 16 : 22
                            }, {
                              default: _withCtx(() => [
                                (!!slotProps.data.attendance[col.field])
                                  ? (_openBlock(), _createBlock(_component_check, { key: 0 }))
                                  : (_openBlock(), _createBlock(_component_close_circle, { key: 1 }))
                              ]),
                              _: 2
                            }, 1032, ["strokeColor", "size"]))
                      ], 2))
                ])
              ]),
              _: 2
            }, 1032, ["field"]))
          }), 128)),
          _createVNode(_component_Column, {
            field: "id",
            style: {"width":"72px"},
            frozen: "",
            alignFrozen: "right"
          }, {
            header: _withCtx(() => [
              _hoisted_9
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_component_overlay_menu, {
                class: "p-d-flex p-jc-center full-width",
                options: _ctx.setMenuOptions(slotProps.data.id)
              }, null, 8, ["options"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ], 64))
}